"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var parse_1 = tslib_1.__importDefault(require("date-fns/parse"));
exports.STATUS_ORDER = [
    'goal_selection',
    'goal_selected',
    'no_goal_selected',
    'no_progress',
    'progress_loaded_no_issuance',
    'final_issuance'
];
function programViewSort(a, b) {
    if (a.programViewStatus !== b.programViewStatus) {
        return exports.STATUS_ORDER.indexOf(a.programViewStatus) - exports.STATUS_ORDER.indexOf(b.programViewStatus);
    }
    return parse_1.default(a.goalSelectionToDate || 0) > parse_1.default(b.goalSelectionToDate || 0) ? -1 : 1;
}
exports.programViewSort = programViewSort;
//# sourceMappingURL=utils.js.map